import React from "react";
import "./Offer.css";
import offer1 from "../../assets/offer1.jpg";
import offer2 from "../../assets/offer2.jpg";
import offer3 from "../../assets/offer3.jpg";
const offerImage = [
  {
    pic: offer1,
  },
  {
    pic: offer2,
  },
  {
    pic: offer3,
  },
];
const Offer = () => {
  return (
    <div className="offer-grid">
      {offerImage.map((item, index) => (
        <div className="offer-card" key={index}>
          <div className="imagess">
            <img src={item.pic} alt="img" className="offer-image" />
          </div>
         
        </div>
      ))}
    </div>
  );
};
export default Offer;